import React from "react";

export const MobileIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
  >
    <path
      d="M15 29.8656H21V28.3656H15V29.8656ZM10.6345 34.7781C9.68997 34.7781 8.88508 34.4455 8.21988 33.7803C7.55466 33.1151 7.22205 32.3102 7.22205 31.3656V4.63467C7.22205 3.69009 7.55466 2.88521 8.21988 2.22001C8.88508 1.55478 9.68997 1.22217 10.6345 1.22217H25.3655C26.3101 1.22217 27.115 1.55478 27.7802 2.22001C28.4454 2.88521 28.778 3.69009 28.778 4.63467V31.3656C28.778 32.3102 28.4454 33.1151 27.7802 33.7803C27.115 34.4456 26.3101 34.7782 25.3655 34.7782L10.6345 34.7781ZM10.6345 26.8656H25.3655V6.13467H10.6345V26.8656Z"
      fill="black"
    />
  </svg>
);
